export const imagenes=[
    {
        id: 1,
        image: '../images/1OCT1.jpg',
        category: '1OCT'
    },
    {
        id: 2,
        image: '../images/1OCT2.jpg',
        category: '1OCT'
    },
    {
        id: 3,
        image: '../images/1OCT3.jpg',
        category: '1OCT'
    },
    {
        id: 4,
        image: '../images/1OCT4.jpg',
        category: '1OCT'
    },
    {
        id: 5,
        image: '../images/1OCT5.jpg',
        category: '1OCT'
    },
    {
        id: 6,
        image: '../images/1OCT6.jpg',
        category: '1OCT'
    },
    {
        id: 7,
        image: '../images/1OCT7.jpg',
        category: '1OCT'
    },
    {
        id: 9,
        image: '../images/1OCT9.jpg',
        category: '1OCT'
    },
    {
        id: 10,
        image: '../images/1OCT10.jpg',
        category: '1OCT'
    },
    {
        id: 11,
        image: '../images/1OCT11.jpg',
        category: '1OCT'
    },
    {
        id: 12,
        image: '../images/1OCT12.jpg',
        category: '1OCT'
    },
    {
        id: 13,
        image: '../images/24M1.jpg',
        category: '24M'
    },
    {
        id: 14,
        image: '../images/24M2.jpg',
        category: '24M'
    },
    {
        id: 15,
        image: '../images/24M3.jpg',
        category: '24M'
    },
    {
        id: 16,
        image: '../images/24M4.jpg',
        category: '24M'
    },
    {
        id: 17,
        image: '../images/24M5.jpg',
        category: '24M'
    },
    {
        id: 18,
        image: '../images/24M6.jpg',
        category: '24M'
    },
    {
        id: 19,
        image: '../images/24M7.jpg',
        category: '24M'
    },
    {
        id: 20,
        image: '../images/24M8.jpg',
        category: '24M'
    },
    {
        id: 21,
        image: '../images/24M9.jpg',
        category: '24M'
    },
    {
        id: 22,
        image: '../images/24M10.jpg',
        category: '24M'
    },
    {
        id: 23,
        image: '../images/24M11.jpg',
        category: '24M'
    },
    {
        id: 24,
        image: '../images/24M12.jpg',
        category: '24M'
    },
    {
        id: 25,
        image: '../images/24M13.jpg',
        category: '24M'
    },
    {
        id: 26,
        image: '../images/24M14.jpg',
        category: '24M'
    },
    {
        id: 27,
        image: '../images/24M15.jpg',
        category: '24M'
    },
    {
        id: 28,
        image: '../images/24M16.jpg',
        category: '24M'
    },
    {
        id: 29,
        image: '../images/24M17.jpg',
        category: '24M'
    },
    {
        id: 30,
        image: '../images/24M18.jpg',
        category: '24M'
    },
    {
        id: 31,
        image: '../images/24M19.jpg',
        category: '24M'
    },
    {
        id: 32,
        image: '../images/24M20.jpg',
        category: '24M'
    },
    {
        id: 33,
        image: '../images/24M21.jpg',
        category: '24M'
    },
    {
        id: 34,
        image: '../images/24M22.jpg',
        category: '24M'
    },
    {
        id: 35,
        image: '../images/24M23.jpg',
        category: '24M'
    },
    {
        id: 36,
        image: '../images/24M24.jpg',
        category: '24M'
    },
    {
        id: 37,
        image: '../images/24M25.jpg',
        category: '24M'
    },
    {
        id: 38,
        image: '../images/24M26.jpg',
        category: '24M'
    },
    {
        id: 39,
        image: '../images/24M27.jpg',
        category: '24M'
    },
    {
        id: 40,
        image: '../images/24M28.jpg',
        category: '24M'
    },
    {
        id: 41,
        image: '../images/24M29.jpg',
        category: '24M'
    },
    {
        id: 42,
        image: '../images/24M30.jpg',
        category: '24M'
    },
    {
        id: 43,
        image: '../images/24M31.jpg',
        category: '24M'
    },
    {
        id: 44,
        image: '../images/24M32.jpg',
        category: '24M'
    },
    {
        id: 45,
        image: '../images/24M33.jpg',
        category: '24M'
    },
    {
        id: 46,
        image: '../images/24M34.jpg',
        category: '24M'
    },
    {
        id: 47,
        image: '../images/24M35.jpg',
        category: '24M'
    },
    {
        id: 47.1,
        image: '../images/24M36.jpg',
        category: '24M'
    },
    {
        id: 48,
        image: '../images/diada castellera san jose 1.jpg',
        category: 'diada castellera san jose'
    },
    {
        id: 49,
        image: '../images/diada castellera san jose 2.jpg',
        category: 'diada castellera san jose'
    },
    {
        id: 50,
        image: '../images/diada castellera san jose 3.jpg',
        category: 'diada castellera san jose'
    },
    {
        id: 51,
        image: '../images/diada castellera san jose 4.jpg',
        category: 'diada castellera san jose'
    },
    {
        id: 52,
        image: '../images/diada castellera san jose 5.jpg',
        category: 'diada castellera san jose'
    },
    {
        id: 53,
        image: '../images/diada castellera san jose 6.jpg',
        category: 'diada castellera san jose'
    },

    {
        id: 54,
        image: '../images/SAMUEL 1.jpg',
        category: 'SAMUEL'
    },
    {
        id: 55,
        image: '../images/SAMUEL 2.jpg',
        category: 'SAMUEL'
    },
    {
        id: 56,
        image: '../images/SAMUEL 3.jpg',
        category: 'SAMUEL'
    },
    {
        id: 57,
        image: '../images/SAMUEL 4.jpg',
        category: 'SAMUEL'
    },
    {
        id: 58,
        image: '../images/SAMUEL 5.jpg',
        category: 'SAMUEL'
    },
    {
        id: 59,
        image: '../images/SAMUEL 6.jpg',
        category: 'SAMUEL'
    },
    {
        id: 60,
        image: '../images/SAMUEL 7.jpg',
        category: 'SAMUEL'
    },
    {
        id: 61,
        image: '../images/SAMUEL 8.jpg',
        category: 'SAMUEL'
    },
    {
        id: 62,
        image: '../images/CLIMATESTRIKE-1.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 63,
        image: '../images/CLIMATESTRIKE-2.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 64,
        image: '../images/CLIMATESTRIKE-3.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 65,
        image: '../images/CLIMATESTRIKE-4.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 66,
        image: '../images/CLIMATESTRIKE-5.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 67,
        image: '../images/CLIMATESTRIKE-6.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 68,
        image: '../images/CLIMATESTRIKE-7.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 69,
        image: '../images/CLIMATESTRIKE-8.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 70,
        image: '../images/CLIMATESTRIKE-9.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 71,
        image: '../images/CLIMATESTRIKE-10.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 72,
        image: '../images/CLIMATESTRIKE-11.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 73,
        image: '../images/CLIMATESTRIKE-12.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 74,
        image: '../images/CLIMATESTRIKE-13.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 75,
        image: '../images/CLIMATESTRIKE-14.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 76,
        image: '../images/CLIMATESTRIKE-15.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 77,
        image: '../images/CLIMATESTRIKE-16.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 78,
        image: '../images/CLIMATESTRIKE-17.jpg',
        category: 'CLIMATESTRIKE'
    },
    {
        id: 79,
        image: '../images/DEFUNI-1.jpg',
        category: 'DEFUNI'
    },
    {
        id: 80,
        image: '../images/DEFUNI-2.jpg',
        category: 'DEFUNI'
    },
    {
        id: 81,
        image: '../images/DEFUNI-3.jpg',
        category: 'DEFUNI'
    },
    {
        id: 82,
        image: '../images/DEFUNI-4.jpg',
        category: 'DEFUNI'
    },
    {
        id: 83,
        image: '../images/DEFUNI-5.jpg',
        category: 'DEFUNI'
    },
    {
        id: 84,
        image: '../images/DEFUNI-6.jpg',
        category: 'DEFUNI'
    },
    {
        id: 85,
        image: '../images/DEFUNI-7.jpg',
        category: 'DEFUNI'
    },
    {
        id: 86,
        image: '../images/DEFUNI-8.jpg',
        category: 'DEFUNI'
    },
    {
        id: 87,
        image: '../images/DEFUNI-9.jpg',
        category: 'DEFUNI'
    },
    {
        id: 88,
        image: '../images/DEFUNI-10.jpg',
        category: 'DEFUNI'
    },
    {
        id: 89,
        image: '../images/DIADA19-1.jpg',
        category: 'DIADA19'
    },
    {
        id: 90,
        image: '../images/DIADA19-2.jpg',
        category: 'DIADA19'
    },
    {
        id: 91,
        image: '../images/DIADA19-3.jpg',
        category: 'DIADA19'
    },
    {
        id: 92,
        image: '../images/DIADA19-4.jpg',
        category: 'DIADA19'
    },
    {
        id: 93,
        image: '../images/DIADA19-5.jpg',
        category: 'DIADA19'
    },
    {
        id: 94,
        image: '../images/DIADA19-6.jpg',
        category: 'DIADA19'
    },
    {
        id: 95,
        image: '../images/DIADA19-7.jpg',
        category: 'DIADA19'
    },
    {
        id: 96,
        image: '../images/DIADA19-8.jpg',
        category: 'DIADA19'
    },
    {
        id: 97,
        image: '../images/DIADA19-9.jpg',
        category: 'DIADA19'
    },
    {
        id: 98,
        image: '../images/DIADA19-10.jpg',
        category: 'DIADA19'
    },
    {
        id: 99,
        image: '../images/RURAL1.jpg',
        category: 'RURAL'
    },
    {
        id: 100,
        image: '../images/RURAL2.jpg',
        category: 'RURAL'
    },
    {
        id: 101,
        image: '../images/RURAL3.jpg',
        category: 'RURAL'
    },
    {
        id: 102,
        image: '../images/RURAL4.jpg',
        category: 'RURAL'
    },
    {
        id: 103,
        image: '../images/RURAL5.jpg',
        category: 'RURAL'
    },
    {
        id: 104,
        image: '../images/RURAL6.jpg',
        category: 'RURAL'
    },
    {
        id: 105,
        image: '../images/RURAL7.jpg',
        category: 'RURAL'
    },
    {
        id: 106,
        image: '../images/RURAL8.jpg',
        category: 'RURAL'
    },
    {
        id: 107,
        image: '../images/RURAL9.jpg',
        category: 'RURAL'
    },
    {
        id: 108,
        image: '../images/hispanidad-1.jpg',
        category: 'hispanidad'
    },
    {
        id: 109,
        image: '../images/hispanidad-2.jpg',
        category: 'hispanidad'
    },
    {
        id: 110,
        image: '../images/hispanidad-3.jpg',
        category: 'hispanidad'
    },
    {
        id: 111,
        image: '../images/hispanidad-4.jpg',
        category: 'hispanidad'
    },
    {
        id: 112,
        image: '../images/hispanidad-5.jpg',
        category: 'hispanidad'
    },
    {
        id: 113,
        image: '../images/hispanidad-6.jpg',
        category: 'hispanidad'
    },
    {
        id: 114,
        image: '../images/hispanidad-7.jpg',
        category: 'hispanidad'
    },
    {
        id: 115,
        image: '../images/hispanidad-8.jpg',
        category: 'hispanidad'
    },
    {
        id: 116,
        image: '../images/MASACREMELILLA-1.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 117,
        image: '../images/MASACREMELILLA-2.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 118,
        image: '../images/MASACREMELILLA-3.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 119,
        image: '../images/MASACREMELILLA-4.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 120,
        image: '../images/MASACREMELILLA-5.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 121,
        image: '../images/MASACREMELILLA-6.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 122,
        image: '../images/MASACREMELILLA-7.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 123,
        image: '../images/MASACREMELILLA-8.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 124,
        image: '../images/MASACREMELILLA-9.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 125,
        image: '../images/MASACREMELILLA-10.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 126,
        image: '../images/MASACREMELILLA-11.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 127,
        image: '../images/MASACREMELILLA-12.jpg',
        category: 'MASACREMELILLA'
    },
    {
        id: 128,
        image: '../images/SAMUEL2-1.jpg',
        category: 'SAMUEL2'
    },
    {
        id: 129,
        image: '../images/SAMUEL2-2.jpg',
        category: 'SAMUEL2'
    },
    {
        id: 130,
        image: '../images/SAMUEL2-3.jpg',
        category: 'SAMUEL2'
    },
    {
        id: 131,
        image: '../images/SAMUEL2-4.jpg',
        category: 'SAMUEL2'
    },
    {
        id: 132,
        image: '../images/SAMUEL2-5.jpg',
        category: 'SAMUEL2'
    },
    {
        id: 133,
        image: '../images/SAMUEL2-6.jpg',
        category: 'SAMUEL2'
    },
    {
        id: 134,
        image: '../images/SAMUEL2-7.jpg',
        category: 'SAMUEL2'
    },
    {
        id: 135,
        image: '../images/SAMUEL2-8.jpg',
        category: 'SAMUEL2'
    },
    {
        id: 136,
        image: '../images/NOAMPLIACIO-1.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 137,
        image: '../images/NOAMPLIACIO-2.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 138,
        image: '../images/NOAMPLIACIO-3.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 139,
        image: '../images/NOAMPLIACIO-4.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 140,
        image: '../images/NOAMPLIACIO-5.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 141,
        image: '../images/NOAMPLIACIO-6.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 142,
        image: '../images/NOAMPLIACIO-7.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 143,
        image: '../images/NOAMPLIACIO-8.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 144,
        image: '../images/NOAMPLIACIO-9.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 145,
        image: '../images/NOAMPLIACIO-10.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 146,
        image: '../images/NOAMPLIACIO-11.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 147,
        image: '../images/NOAMPLIACIO-12.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 148,
        image: '../images/NOAMPLIACIO-13.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 149,
        image: '../images/NOAMPLIACIO-14.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 150,
        image: '../images/NOAMPLIACIO-15.jpg',
        category: 'NOAMPLIACIO'
    },
    {
        id: 151,
        image: '../images/VAGAGRAL-1.jpg',
        category: '1OCT'
    },
    {
        id: 152,
        image: '../images/VAGAGRAL-2.jpg',
        category: '1OCT'
    },
    {
        id: 153,
        image: '../images/VAGAGRAL-3.jpg',
        category: '1OCT'
    },
    {
        id: 154,
        image: '../images/VAGAGRAL-4.jpg',
        category: '1OCT'
    },
    {
        id: 155,
        image: '../images/VAGAGRAL-5.jpg',
        category: '1OCT'
    },
    {
        id: 156,
        image: '../images/VAGAGRAL-6.jpg',
        category: '1OCT'
    },
    {
        id: 157,
        image: '../images/VAGAGRAL-7.jpg',
        category: '1OCT'
    },
    {
        id: 158,
        image: '../images/VAGAGRAL-8.jpg',
        category: '1OCT'
    },
    {
        id: 159,
        image: '../images/VAGAGRAL-9.jpg',
        category: '1OCT'
    },
    {
        id: 160,
        image: '../images/VAGAGRAL-10.jpg',
        category: '1OCT'
    },


    


  ];